import fetch from 'isomorphic-fetch';
import { notification } from 'antd';
import { RouterState } from 'mobx-state-router';

var rootStore;

const codeMessage = {
  200: 'Request was successfully responded',
  201: 'Successfully created or updated the data',
  202: 'Request has been queued and will be proccessed soon',
  204: 'Successfully deleted the data',
  400: 'There was an error, no modification has been made',
  401: 'User does not have permission',
  403: 'User is authorized but access is forbidden',
  404: 'Resource does not exist',
  406: 'Format of request is incorrect',
  410: 'Resource deleted and could not be accessed',
  422: 'A validation error occurred while creating an object',
  500: 'Server error',
  502: 'Gateway error',
  503: 'Service unavailable',
  504: 'Gateway timeout',
};
 
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  notification.error({
    message: `Request Error ${response.status}: ${response.url}`,
    description: errortext,
  });
  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
}

export function setRootStore(store) {
  rootStore = store;
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options) {
  const defaultOptions = {
    credentials: 'include',
  };
  const newOptions = { ...defaultOptions, ...options };
  if (newOptions.method === 'POST' || newOptions.method === 'PUT' || newOptions.method == "DELETE") {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...newOptions.headers,
      };
      if (typeof newOptions.body !== "string") {
        newOptions.body = JSON.stringify(newOptions.body);
      }      
    } else {
      // newOptions.body is FormData
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        ...newOptions.headers,
      };
    }
  }

  return fetch(url, newOptions)
    .then(checkStatus)
    .then((response) => {
      // if (newOptions.method === 'DELETE' || response.status === 204) {
      //   return response.text();
      // }
      return response.json();
    })
    .catch((e) => {      
      const status = e.name;
      if (status === 401) {    
        const userStore = rootStore.userStore;
        const routerStore = rootStore.routerStore;
        userStore.setSignInRedirect(routerStore.routerState);
        routerStore.goTo(new RouterState("login"));
        // return {
        //   error: {
        //     message: "You need to login"
        //   }
        // };
        return;
      }
      if (status === 403) {        
        return;
      }
      if (status <= 504 && status >= 500) {        
        return;
      }
      if (status >= 404 && status < 422) {
        return;
      }
    });
}
